import { getToothNumberById, TeethNumberingSystem } from '@modules/rx-intuitive-teeth-orchestrator/models';
import type { IntuitiveBridge } from '@modules/rx-intuitive-teeth-orchestrator/models/intuitive-bridge';

const EN_DASH = '\u2013';

/**
 * Formats a bridge span from outer tooth ids, e.g. #32–35, using the same numbering system as the diagram.
 */
export const formatBridgeSpanDisplayFromToothIds = (
	outerLeftToothId: number,
	outerRightToothId: number,
	teethNumberingSystem: TeethNumberingSystem
): string => {
	const firstId = Math.min(outerLeftToothId, outerRightToothId);
	const lastId = Math.max(outerLeftToothId, outerRightToothId);
	const first = getToothNumberById({ toothId: firstId, teethNumberingSystem });
	const last = getToothNumberById({ toothId: lastId, teethNumberingSystem });

	return `#${String(first)}${EN_DASH}${String(last)}`;
};

/**
 * Formats a bridge span when outer tooth numbers are already resolved for the active numbering system.
 */
export const formatBridgeSpanDisplayFromResolvedNumbers = (left: string | number, right: string | number): string => {
	return `#${String(left)}${EN_DASH}${String(right)}`;
};

/**
 * Formats a bridge as a display span, e.g. #32–35, using the same numbering system as the diagram.
 */
export const formatBridgeSpanDisplay = (bridge: IntuitiveBridge, teethNumberingSystem: TeethNumberingSystem): string => {
	return formatBridgeSpanDisplayFromToothIds(bridge.outerLeftToothId ?? 0, bridge.outerRightToothId ?? 0, teethNumberingSystem);
};
